import OaApiService from './OaApiService';

export default class AccountService extends OaApiService {
  constructor(apiHandler) {
    super(apiHandler);
  }

  getPremierStartDate(userKey) {
    return this.get('/AccountREST/premier-commencement-date', { userKey });
  }
}
